import { displayDateTimeCSV } from "@common/utils/localTime.utils";
import { TicketEvent } from "@services/tickets/types";
import { TFunction } from "react-i18next";

export const getColumns = (
  t: TFunction<"translation", undefined>,
  tz?: string
): ColDef<TicketEvent>[] => {
  const colDefForCSV: ColDef<TicketEvent>[] = [
    {
      key: "priority",
      label: t("Priority"),
      csvValue: (row) => row.priority ?? "",
    },
    {
      key: "description",
      label: t("Description"),
      csvValue: (row) => row.description ?? "",
    },
  ];
  if (tz) {
    colDefForCSV.unshift({
      key: "createDate",
      label: t("Created At (Source Time)"),
      csvValue: (row) => displayDateTimeCSV(row.createDate, tz),
    });
    colDefForCSV.unshift({
      key: "id",
      label: t("Created At (User Time)"),
      csvValue: (row) => displayDateTimeCSV(row.createDate),
    });
  } else {
    colDefForCSV.unshift({
      key: "createDate",
      label: t("Created At"),
      csvValue: (row) => displayDateTimeCSV(row.createDate),
    });
  }

  return colDefForCSV;
};

export const getLast100 = (events: TicketEvent[]) =>
  events
    .sort(({ createDate: a }, { createDate: b }) => Math.sign(b - a))
    .slice(0, 100);
